import { MCPToolName } from "@qw/qw-common";

import type { ToolFilter } from "../chat/providers/chat-provider";

// Never whitelist an elicit-gated tool here (`@RequiresElicitConfirmation()`,
// e.g. `transitionOpportunity` / `notifyAgent`): `buildForegroundToolFilter`
// strips `MCPToolName.Elicit` from every foreground tool set, so the elicit the
// guard requires can never exist and every call throws. Confirmed writes reach
// book chat through `ExecutePlaybook`, where elicit is available.
export const BOOK_CHAT_TOOL_FILTER: ToolFilter = {
  whitelist: [
    MCPToolName.GetBookOverview,
    MCPToolName.FindStaleMarketingPlans,
    MCPToolName.GetOpportunityContext,
    // Whitelisted alongside GetOpportunityContext rather than on its own merits: that tool's
    // description tells a caller to reach for this one when it wants appetite text a projected
    // submission omitted. Without it here, following that guidance on this surface is a dead end.
    MCPToolName.GetAppetiteProductText,
    MCPToolName.GetSubmissions,
    MCPToolName.GetQuotesBySubmission,
    MCPToolName.SearchFilesForInformation,
    MCPToolName.AddOpportunityNote,
    MCPToolName.RequestFollowUp,
    MCPToolName.PlaybookDiscovery,
    MCPToolName.PlaybookReader,
    MCPToolName.ExecutePlaybook,
    MCPToolName.ListMyBook,
    MCPToolName.SendSlackMessage,
    MCPToolName.NotifyService,
    MCPToolName.NotifyAccounting,
    MCPToolName.SendRenewalEmail,
  ],
};
